import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Mail, ArrowLeft, AlertTriangle, Play } from 'lucide-react';
import { API_BASE_URL } from '../../firebase/firebaseConfig';

function SignIn({ onEmailSubmit }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [emailDisabled, setEmailDisabled] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send email to backend
    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/signin`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (data.allowed) {
        // Proceed to code verification
        onEmailSubmit(email);
      } else {
        // Show message and disable email input
        setMessage(data.message || 'You are not on the pre-approved list.');
        setEmailDisabled(true);
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('An error occurred. Please try again.');
    }
  };

  const handleGoBack = () => {
    setEmailDisabled(false);
    setMessage('');
  };

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="flex items-center justify-center gap-2 text-2xl">
            <Mail className="w-6 h-6" />
            Admin Sign In
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium mb-2 block">Email address</label>
              <Input
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={emailDisabled}
                required
                onKeyDown={(event) => {
                  if (event.key === 'Enter' && !emailDisabled) {
                    handleSubmit(event);
                  }
                }}
              />
            </div>
            {!emailDisabled && (
              <Button type="submit" className="w-full flex items-center justify-center gap-2">
                <Play className="w-4 h-4" />
                Start
              </Button>
            )}
          </form>
          {message && (
            <div className="mt-4 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
              <div className="flex items-center gap-2 text-destructive mb-3">
                <AlertTriangle className="w-4 h-4" />
                <p className="text-sm">{message}</p>
              </div>
              <Button 
                variant="outline" 
                onClick={handleGoBack}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                Go Back
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default SignIn;
